import {Accordion, Button, Col, Row, Table} from "react-bootstrap";
import React, {useEffect} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {useGetMultiImports} from "../../api/importsV2/useMultiImports";
import {useDisableMultiImport, useEnableMultiImport} from "../../api/importsV2/useDisableEnableMultiImports";
import {Loading} from "../../components/Loading";
import {
    LeasePackageMultiImportDto,
    LeasePackageMultiImportSimpleDto
} from "../../model/Imports";
import notifier from "simple-react-notifications2";
import {
    DatatableWrapper,
    Filter,
    Pagination,
    PaginationOptions,
    TableBody,
    TableColumnType,
    TableHeader
} from "react-bs-datatable";
import Container from "react-bootstrap/Container";
import {TablePaginationOptionsParameters} from "react-bs-datatable/lib/esm/components/DatatableWrapper";
import {useDisableImport, useEnableImport} from "../../api/imports/useDisableEnableImports";
import {ImportHeader} from "../imports/components/ImportHeader";
import {VehicleWithPackages} from "../imports/components/VehicleWithPackages";
import {useGetMultiImport} from "../../api/importsV2/useMultiImport";

export function ImportV2() {
    const {importId} = useParams();
    const {loading, data, error, execute} = useGetMultiImport();


    const {loading: loadingEnable, error: errorEnable, execute: executeEnable} = useEnableMultiImport();
    const {loading: loadingDisable, error: errorDisable, execute: executeDisable} = useDisableMultiImport();

    useEffect(() => {
        load();
    }, [importId]);

    if(loading) return (<Loading/>)
    if(data === undefined || !data) return (<>No data</>)

    function load() {
        if(importId) {
            execute(importId);
        }
    }
    function enable(id: number) {
        executeEnable(id)
    }

    function disable(id: number) {
        executeDisable(id)
    }

    function getSortedImports() {
        if(! data) return [];
        return data.tenantImports.sort((a, b) => b.id - a.id)
    }

    return (
        <>
            <Container>
               <Row className="mb-2 mt-5">
                   <Col>
                       {(loadingDisable || loadingEnable) && (<Loading/>)}
                       <Button className="button-outline" size={"sm"} onClick={() => {
                           if(data.enabled) {disable(data.id)} else {enable(data.id)}
                       }}>
                           {data.enabled ? 'Disable' : 'Enable'}
                       </Button>
                   </Col>
               </Row>
            <Row>
                <Accordion>
                    {getSortedImports().map((it, index) => (
                        <Accordion.Item key={'Ims' + it.id} eventKey={index.toString()}>
                            <Accordion.Header><ImportHeader import={it}/></Accordion.Header>
                            <Accordion.Body>
                                <VehicleWithPackages import={it} reload={load}/>
                            </Accordion.Body>
                        </Accordion.Item>
                    ))}
                </Accordion>
            </Row>
            </Container>
        </>
    )
}

export function MultiImportHeader(
    props: {import: LeasePackageMultiImportDto}
) {


    return (
        <>
            <Row>
                <Col>{props.import.id}</Col>
                <Col>{props.import.created.toString()}</Col>
                <Col>{props.import.enabled ? 'Active' : 'Disabled'}</Col>
                {(props.import.filename && props.import.filename.trim().length > 0) ? (
                    <Col xs={7}>{props.import.filename}</Col>
                ): (<></>)}
            </Row>
        </>
    )
}